import * as React from 'react'

const GifIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_7337_43582)">
        <path
          fill="#E9F0FA"
          d="m18 0 4 4v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        ></path>
        <path fill="#C2CDDE" d="M22 4h-4V0z"></path>
      </g>
      <rect width="22" height="10" x="1" y="10" fill="#F17048" rx="1"></rect>
      <path
        fill="#fff"
        d="M10.01 14.04a1.5 1.5 0 0 0-.195-.412 1.3 1.3 0 0 0-.296-.316 1.2 1.2 0 0 0-.392-.195 1.6 1.6 0 0 0-.483-.069q-.468 0-.835.236a1.6 1.6 0 0 0-.577.693q-.207.455-.207 1.108 0 .66.207 1.117t.577.696q.369.236.858.236.443 0 .767-.17.326-.172.503-.484a1.5 1.5 0 0 0 .176-.739l.239.037h-1.58v-.824h2.36v.7q0 .746-.317 1.292a2.17 2.17 0 0 1-.875.84 2.7 2.7 0 0 1-1.279.293q-.803 0-1.412-.36a2.5 2.5 0 0 1-.946-1.032q-.338-.67-.338-1.59 0-.705.2-1.259.2-.555.562-.94.36-.39.846-.591a2.7 2.7 0 0 1 1.057-.205q.483 0 .9.142.418.14.742.398.327.258.537.614.21.354.276.784zm3.196-1.858V18h-1.054v-5.818zM14.347 18v-5.818h3.728v.883H15.4v1.58h2.418v.883H15.4V18z"
      ></path>
      <defs>
        <clipPath id="clip0_7337_43582">
          <path fill="#fff" d="M2 0h20v24H2z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
)

GifIcon.displayName = 'GifIcon'

export { GifIcon }
